//LOCAL
// const MAIN = "http://192.168.1.76:5001";

//LIVE
const MAIN = "https://api.hytechlms.com";

export const URLS = {
  BASE_URL: `${MAIN}/`,
  API_BASE_URL: `${MAIN}/api`,
  IMG_URL: "",
  MAIN
};
